import { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import mainImg from "../../user/pages/assets/dashboard.png";
import { checkInvitationStatus, acceptInvitation } from "../../services/user.services"

const Invitation = () => {
    const location = useLocation();
    const history = useHistory();
    const queryParams = new URLSearchParams(location.search);
    const guestEmail = queryParams.get("guestEmail");
    const ownerEmail = queryParams.get("ownerEmail");
    const inviteId = queryParams.get("inviteId");

    const [loading, setLoading] = useState(false);
    const [isRegistered, setIsRegistered] = useState(null);
    const [error, setError] = useState(null);
    const [inviteAccepted, setInviteAccepted] = useState(false);

    useEffect(() => {
        const fetchStatus = async () => {
            if (!guestEmail || !ownerEmail || !inviteId) {
                setError("Missing required parameters");
                return;
            }

            setLoading(true);
            try {
                // Remove token parameter from the call
                const response = await checkInvitationStatus(guestEmail, ownerEmail);
                console.log("Invitation status response:", response.data);

                setIsRegistered(response.data.guestIsRegistered);

                if (response.data.invitationStatus === "accepted") {
                    setInviteAccepted(true);
                }
            } catch (err) {
                console.error("Error checking user status:", err);
                setError("Failed to check user status. Please try again.");
            } finally {
                setLoading(false);
            }
        };

        fetchStatus();
    }, [guestEmail, ownerEmail, inviteId]);

    const handleAccept = async () => {
        setLoading(true);
        try {
            // Remove token parameter from the call
            await acceptInvitation(inviteId, "accepted");
            
            console.log("Invite accepted for", guestEmail, "from", ownerEmail);
            
            setInviteAccepted(true);
        } catch (err) {
            console.error("Error accepting invitation:", err);
            setError("Failed to accept invitation. Please try again.");
        } finally {
            setLoading(false);
        }
    };

        const handleCreateAccount = async () => {
        setLoading(true);
        try {
            // First accept the invitation
            await acceptInvitation(inviteId, "accepted");
            
            console.log("Invite accepted for", guestEmail, "from", ownerEmail);
            // history.push(`/signup?email=${encodeURIComponent(guestEmail)}&ownerEmail=${encodeURIComponent(ownerEmail)}&inviteId=${encodeURIComponent(inviteId)}`);
            history.push(`/signup`)
        } catch (err) {
            console.error("Error accepting invitation:", err);
            setError("Failed to accept invitation. Please try again.");
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="login">
            <div className="topContent">
                <div className="imageBoxMain">
                    <img src={mainImg} className="headerImage" alt="Dashboard Header" />
                </div>
            </div>
            
            <div className="login-box">
                <div className="user-box">
                    <h4 className="welcomeSubHeading" style={{ color: "white", textAlign: "center" }}>
                        I'd like to invite you to join this account on LaxStatClock. Together
                        we can easily track and manage stats in one place. Looking forward to
                        having you on board!
                    </h4>
                    {guestEmail && (
                        <p style={{ color: "goldenrod", textAlign: "center", marginTop: "10px" }}>
                            Invitation for: <strong>{guestEmail}</strong>
                        </p>
                    )}
                </div>
            </div>
            
            <div className="container">
                {error ? (
                    <div style={{ color: "red", textAlign: "center" }}>{error}</div>
                ) : loading ? (
                    <p style={{ color: "white", textAlign: "center" }}>Checking invitation status...</p>
                ) : isRegistered === null ? (
                    <p style={{ color: "white", textAlign: "center" }}>Unable to determine user status</p>
                ) : inviteAccepted ? (
                    <div className="thank-you-message">
                        <h3 style={{ color: "white", textAlign: "center" }}>Thank You!</h3>
                        <p style={{ color: "white", textAlign: "center" }}>
                            You have successfully accepted the invitation.
                        </p>
                    </div>
                ) : isRegistered ? (
                    <button 
                        className="signup-button" 
                        disabled={loading} 
                        onClick={handleAccept}
                    >
                        {loading ? "Accepting..." : "Accept Invite"}
                    </button>
                ) : (
                    <button
                        className="signup-button"
                        onClick={handleCreateAccount}
                    >
                        Accept & Create Account
                    </button>
                )}
            </div>
        </div>
    );
};

export default Invitation;